import * as React from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import notify from '../../shared/feedback/notifications';
import { Translate } from '../../shared/LanguageService';
import { assign } from '../../shared/Assign';
import { handleError } from '../../shared/ErrorCatching';
import * as imageEditorActions from './ImageEditorsActions';
import ImageEditorUserForm from './ImageEditorUserForm';
import IImageEditorInput from './IImageEditorInput';

export class ImageEditorUserModal extends React.Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            creating: false,
            imageEditor: {
                email: '',
                username: ''
            },
            errors: {},
            imageEditorFirms: []
        };

        this.onSave = this.onSave.bind(this);
        this.addUser = this.addUser.bind(this);
        this.updateUser = this.updateUser.bind(this);
        this.onChange = this.onChange.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentDidMount() {
        if (this.props.editId !== 0) {
            this.props.actions.getEditImageEditor(this.props.editId).then(() => {
                this.setState({ imageEditor: assign({}, this.props.edit) });
            });
        } else {
            this.props.actions.getNewImageEditor();
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (nextProps) {
            this.setState({
                imageEditorFirms: assign([], nextProps.imageEditorFirms)
            });
        }
    }

    onError(errorResponse: any): void {
        let errorMessage: string = '';
        if (errorResponse.errors) {
            errorResponse.errors.forEach((e: any) => {
                errorMessage += e.value;
            });
        } else {
            errorMessage = Translate(errorResponse.innerException.exceptionMessage);
        }

        notify.failure(errorMessage);
    }

    onChange(e: any): void {
        let imageEditor = this.state.imageEditor;
        const value = e.target.value;

        imageEditor[e.target.name] = value;

        this.setState({ imageEditor: assign({}, imageEditor) });
    }

    checkForEmail() {
        let imageEditor = this.state.imageEditor;

        if (!imageEditor.email && imageEditor.username) {
            imageEditor.email = imageEditor.username;

            this.setState({ imageEditor: assign({}, imageEditor) });
        }
    }

    addUser() {
        this.props.actions
            .addImageUser(this.state.imageEditor)
            .then(() => {
                this.setState({ creating: false });
                this.props.closeModal();
                notify.success(Translate('image-editors/notification/user-created'));
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, creating: false });
                })
            );
    }

    onSave(): void {
        this.setState({ creating: true });
        if (this.props.editId === 0) {
            this.checkForEmail();
            this.addUser();
        } else {
            this.updateUser();
        }
    }

    updateUser() {
        this.props.actions
            .editImageUser(this.state.imageEditor.id, this.state.imageEditor)
            .then(() => {
                this.setState({ creating: false });
                this.props.closeModal();
                notify.success(Translate('image-editors/notification/user-updated'));
            })
            .catch((error: any) =>
                handleError(error, (errors: any): void => {
                    this.setState({ errors: errors, creating: false });
                })
            );
    }

    closeModal() {
        this.props.closeModal();
    }

    render() {
        return (
            <div>
                <Modal show={this.props.shouldShowModal} onHide={this.closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {this.props.editId === 0
                                ? Translate('image-editors/modal/title/add-image-editor')
                                : Translate('image-editors/modal/title/edit-image-editor')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ImageEditorUserForm
                            imageEditor={this.state.imageEditor}
                            onChange={this.onChange}
                            editId={this.props.editId}
                            errors={this.state.errors}
                            isEditMode={this.props.editId !== 0}
                            imageEditorFirms={this.state.imageEditorFirms}
                            availableLanguages={this.props.availableLanguages}
                            availableRoles={this.props.availableRoles}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.closeModal}>
                            {Translate('image-editors/modal/create/footer/button-label/close')}
                        </Button>
                        <Button
                            bsStyle="primary"
                            disabled={this.state.creating}
                            onClick={this.onSave}
                        >
                            {this.state.creating === true
                                ? Translate('image-editors/modal/create/footer/button-label/close')
                                : Translate('se360users/modal/footer/button-label/save')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        edit: state.imageEditors.edit,
        imageEditorFirms: state.imageEditors.modal.imageEditorFirms,
        availableLanguages: state.imageEditors.modal.availableLanguages,
        availableRoles: state.imageEditors.modal.availableRoles
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            addImageUser: (user: IImageEditorInput) =>
                dispatch(imageEditorActions.addImageEditor(user)),
            editImageUser: (userId: number, user: IImageEditorInput) =>
                dispatch(imageEditorActions.updateImageEditor(userId, user)),
            getEditImageEditor: (id: number) => dispatch(imageEditorActions.getEditImageEditor(id)),
            getNewImageEditor: () => dispatch(imageEditorActions.getNewImageEditor())
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageEditorUserModal);
